const timeTool = {
  nowTime () {
    const now = new Date()
    const year = now.getFullYear() // 年份
    const month = now.getMonth()// 月份
    const date = now.getDate()// 日
    const day = now.getDay() + 1// 周
    const hour = now.getHours()// 时
    const minu = now.getMinutes()// 分
    const sec = now.getSeconds()// 秒
    const MS = now.getMilliseconds()// 毫秒
    return { data: { year: year, month: month, date: date, day: day, hour: hour, minu: minu, sec: sec, ms: MS } }
  },
  greet (hour) {
    const hourNum = Number(hour)
    if (hourNum >= 1 && hourNum < 6) {
      return '凌晨好！'
    }
    if (hourNum >= 6 && hourNum < 12) {
      return '早上好！'
    }
    if (hourNum >= 12 && hourNum < 13) {
      return '中午好！'
    }
    if (hourNum >= 13 && hourNum < 19) {
      return '下午好！'
    }
    if (hourNum >= 19 && hourNum <= 23) {
      return '晚上好！'
    }
    if (hourNum === 0) {
      return '晚上好！'
    }
  }
}
export default timeTool
